import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils.js";

const baseUrl = "/api/sif/aplikacijaSemena";

export const fetchSeedApplication = createAsyncThunk(
  "seedApplication/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchSeedApplicationPage = createAsyncThunk(
  "seedApplication/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchSeedApplicationBySifra = createAsyncThunk(
  "seedApplication/byCode",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const seedApplicationSlice = createSlice({
  name: "seedApplication",
  initialState: {
    page: null,
    list: [],
    byId: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSeedApplication.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(fetchSeedApplication.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchSeedApplication.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSeedApplicationPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchSeedApplicationPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchSeedApplicationPage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSeedApplicationBySifra.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSeedApplicationBySifra.fulfilled, (state, action) => {
        state.isLoading = false;
        const item = action.payload;
        if (item?.sifra) {
          state.byId[item.sifra] = item;
          state.details = item.sifra;
        }
      })
      .addCase(fetchSeedApplicationBySifra.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default seedApplicationSlice.reducer;
